import React, { useContext, useState } from "react";
import { useParams } from "react-router-dom";
import { Aside, EditButton } from "sprint-common-web";

import { SystemPlatformDetailsContext } from "../../context/SystemPlatformDetailsContext";
import { EditBuzzIdsForm } from "./EditBuzzIdsForm";

export const EditBuzzIdsButton: React.VFC = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false);

    const { systemId } = useParams<{ systemId: string }>();

    const { isLoading } = useContext(SystemPlatformDetailsContext);

    const closeSidebar = () => {
        setIsSidebarOpen(false);
    };

    const openSidebar = () => {
        setIsSidebarOpen(true);
    };

    return (
        <>
            <EditButton onClick={openSidebar} isLabeled label="Edit" disabled={isLoading} testId="edit-buzz-ids" />
            <Aside isOpen={isSidebarOpen} type="form" headerText="Edit" onDismiss={closeSidebar}>
                <EditBuzzIdsForm onCancel={closeSidebar} onSubmit={closeSidebar} systemId={systemId} />
            </Aside>
        </>
    );
};
